module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer"
  }, [(_vm.item.attr === 'address') ? _c('v-address', {
    attrs: {
      "attrValue": _vm.form.address
    },
    on: {
      "change": _vm.addressSave
    }
  }) : (_vm.item.attr === 'customerName') ? [(_vm.item.fieldType === 40) ? _c('div', {
    staticClass: "customerType"
  }, [_c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "customerApi",
      "fromMoudle": "communicateApi",
      "item": _vm.item,
      "form": _vm.form
    },
    on: {
      "addNew": _vm.addNew,
      "emitObj": _vm.changeCustomer
    }
  }), _vm._v(" "), (_vm.formatIsSelectControl()) ? _c('el-select', {
    attrs: {
      "disabled": _vm.item.templateEditeble ? _vm.item.templateEditeble[_vm.templateId] === 1 : _vm.item.selectControl.nonEditable === 1
    },
    on: {
      "change": function($event) {
        _vm.selectHandle(_vm.item.attr)
      }
    },
    model: {
      value: (_vm.item.selectControl.attrValue),
      callback: function($$v) {
        _vm.$set(_vm.item.selectControl, "attrValue", $$v)
      },
      expression: "item.selectControl.attrValue"
    }
  }, _vm._l((_vm.item.selectControl.valueArrMap), function(arr) {
    return _c('el-option', {
      key: arr.key,
      attrs: {
        "label": arr.value,
        "value": arr.key
      }
    })
  })) : _vm._e()], 1) : _vm._e()] : (_vm.item.attr === 'contactArray') ? [(_vm.form.customerName && _vm.form.customerName.id) ? _c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "contactApi",
      "multiselect": true,
      "item": _vm.item,
      "form": _vm.form,
      "customerId": _vm.form.customerName.id
    },
    on: {
      "addNew": _vm.addNew,
      "emitObj": _vm.saveObj
    }
  }) : _c('span', [_vm._v("无")])] : (_vm.item.attr === 'communicateBusiness') ? [(_vm.item.fieldType === 41 && _vm.form.customerName && _vm.form.customerName.id) ? _c('div', {
    staticClass: "communicateType"
  }, [(_vm.item.selectControl && _vm.item.selectControl.valueArrMap) ? _c('el-select', {
    on: {
      "change": function($event) {
        _vm.toggleModuleType(_vm.item.attr)
      }
    },
    model: {
      value: (_vm.item.selectControl.attrValue),
      callback: function($$v) {
        _vm.$set(_vm.item.selectControl, "attrValue", $$v)
      },
      expression: "item.selectControl.attrValue"
    }
  }, _vm._l((_vm.item.selectControl.valueArrMap), function(arr) {
    return _c('el-option', {
      key: arr.key,
      attrs: {
        "label": arr.value,
        "value": arr.key,
        "disabled": arr.enable !== 1
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": _vm.moduleType,
      "item": _vm.item,
      "form": _vm.form,
      "customerId": _vm.form.customerName.id
    },
    on: {
      "addNew": _vm.addNew
    }
  })], 1) : _c('span', [_vm._v("无")])] : (_vm.item.attr === 'communicateTime') ? [_c('el-date-picker', {
    class: {
      disable: _vm.item && _vm.item.nonEditable
    },
    attrs: {
      "editable": false,
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "picker-options": _vm.disableBefore,
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.form[_vm.item.attr]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.item.attr, $$v)
      },
      expression: "form[item.attr]"
    }
  })] : (_vm.item.attr === 'synchronizeCommunicatePlan') ? [(_vm.form.customerName && _vm.form.customerName.id && _vm.form.communicateTime) ? _c('div', {
    staticClass: "item-select"
  }, [(!_vm.form[_vm.item.attr].id) ? _c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": "请点击“选择”添加"
    },
    model: {
      value: (_vm.form[_vm.item.attr].value),
      callback: function($$v) {
        _vm.$set(_vm.form[_vm.item.attr], "value", $$v)
      },
      expression: "form[item.attr].value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form && _vm.form[_vm.item.attr].id) ? _c('span', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.form[_vm.item.attr].value))]), _vm._v(" "), _c('i', {
    staticClass: "del el-icon-close",
    on: {
      "click": function($event) {
        _vm.delVisit()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "select-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleSelectPlan()
      }
    }
  }, [_vm._v("选择")])], 1) : _c('span', [_vm._v("无")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d65ca1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/communicate/index.vue
// module id = 1269
// module chunks = 82